import { API } from "aws-amplify";
import { getYearRecords } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_MONTH_RECORD: APITypes.MonthlyFinanceReport = {
  __typename: "MonthlyFinanceReport",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  yearlyReportId: "",
  entityID: "",
  entityType: "",
  month: 0,
  year: 0,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getMonthlyReport = async (recordId: string) => {
  try {
    const response = (await API.graphql({
      query: getYearRecords,
      variables: {
        id: recordId,
      },
    })) as { data?: APITypes.GetMonthlyFinanceReportQuery };

    return {
      success: true,
      data: response.data?.getMonthlyFinanceReport || EMPTY_MONTH_RECORD,
    };
  } catch (error) {
    console.error("failed to get monthly records", error);
    return {
      success: false,
      data: EMPTY_MONTH_RECORD,
      error,
    };
  }
};
